export const useStores = function () {
  return {
    app: useAppStore(),
    debug: useDebugStore(),
    storyblok: useStoryblokStore(),
    browser: useBrowserStore(),
    dots: useDotsStore(),
  }
}

export default useStores
